<template>
	<!--添加Ip-->
	<el-dialog 
		:visible.sync="dialogVisible" 
		class="join-share-bandwith-container cps-dialog-icon-line-height"
		:title="$t('sbw.text.addIp')" 
		:before-close="doClose" :close-on-click-modal="false">
		<div class="i-text">
	        <div class="tip-warning mb20 lh20"
	             v-html="$t('sbw.text.addIpTip',[bandwidth])">
	        </div>
      	</div>
      	<h3 class="jc-row">
      		<span>{{$t('sbw.text.chooseIpTip0')}}</span>
      		<span class="cps-highlight-font-color detail-name" :title="detailData.name">{{detailData.name}}</span>
      		<span>{{$t('sbw.text.chooseIpTip1')}}</span>
      	</h3>
		<!--eip列表数据-->
		<el-table :data="eipListData" 
			v-loading="refreshLoading" 
			max-height="160" 
			@selection-change="handleSelectionChange">
			<el-table-column
				type="selection"
				width="55">
			</el-table-column>
			<!--IP地址-->
			<el-table-column :label="$t('sbw.text.ipAddress')" min-width="80">
				<template slot-scope="scope">
					<el-tooltip :content="scope.row.elasticIp" class="item" effect="dark" >
						<span>{{scope.row.elasticIp | maybeEmpty}}</span>
					</el-tooltip>
				</template>
			</el-table-column>			
			<!--IP类型-->
			<el-table-column :label="$t('detail.text.ipType')" min-width="80">
				<template slot-scope="scope">
					<el-tooltip :content="scope.row.elasticIp" class="item" effect="dark" >
						<span>{{$t('eip.text.eip')}}</span>
					</el-tooltip>
				</template>
			</el-table-column> 
			<!--带宽-->
			<el-table-column :label="$t('detail.text.currentBandWidth')" min-width="120">
				<template slot-scope="scope">
					<span>
						{{scope.row.bandwidth + 'Mbps'}} {{$t('eip.text.independentBandwidth')}}
					</span>
				</template>
			</el-table-column>
			<!--线路-->
			<el-table-column :label="$t('eip.text.line')" width="90">
				<template slot-scope="scope">
					<span>{{scope.row.lineTypeName | maybeEmpty}}</span>
				</template>
			</el-table-column>
		</el-table>
		<h3 class="jc-row">
			<span>{{$t('sbw.text.remainIpTip0')}}</span>
			<span class="cps-highlight-font-color">{{ipCount}}</span>
			<span>{{$t('sbw.text.remainIpTip1')}}</span>
			<span v-if="ipCount === 0">{{$t('sbw.text.exceedTotalIpCountTip')}}<a v-bind:href="Config.SBW_TIKCET_URL" target="_blank">
			{{$t('eip.help.openTicket')}}
			</a>{{$t('ssh.help.increaseQuota')}}</span>
		</h3>
		<div ref="footer" class="cps-page-footer-simple block jc-container-table-actionBar"
			v-if="total > 0">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="doClose">{{ $t('detail.text.cancel') }}</el-button>
			<el-button @click="doConfirm" type="primary"
				:disabled="!multipleSelection.length || remainIpCount < 0">
				{{ $t('detail.text.sure')}}
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { deepCopy } from '@/common/tool';
import { SbwAddIpMaxCount } from '@/common/Constants';
export default {
	props: {
		dialogVisible: {
			type: Boolean,
			default: true,
		},
		region: {
			type: String,
			default: ''
		},
		detailData: {
			type: Object,
			default: {}
		}
	},
	data() {
		const initPage = 1;
		this.SbwAddIpMaxCount = SbwAddIpMaxCount;
		return {
			openStatus: false,
			// 查询到的eip列表数据
			eipListData: [],
			// 表格加载中状态
			refreshLoading: false,
			// 选择的ip数量
			selectIpCount: 0,
			// eip列表总数
			total: 0,
			pageSize: 10,
			pageSizes: [10, 20, 50, 100], // 可选每页展示多少条,
			currentPage: initPage,
			multipleSelection: []
		};
	},
	computed: {
		bandwidth() {
		 	return this.detailData.bandwidth
		},
		//展示的剩余可添加的Ip数量
		ipCount() {
			let remain = this.SbwAddIpMaxCount-this.detailData.ipCount-this.selectIpCount;
			return remain <= 0 ? 0: remain
		},
		//按钮置灰的ip判断条件
		remainIpCount() {
			return this.SbwAddIpMaxCount-this.detailData.ipCount-this.selectIpCount;
		}
	},
	watch: {
	},
	created() {
		this.getEipListData();
	},
	methods: {
		// 关闭弹框
		doClose() {
			this.$emit('update:dialogVisible', false);

		},
		// 点击确认按钮，加入共享带宽
		doConfirm() {
			let elasticIpIds = this.multipleSelection.map(item=>item.elasticIpId);
			let region = this.region;
			let bandwidthPackageId = this.detailData.bandwidthPackageId;
			const params = {
				region,
				elasticIpIds,
				bandwidthPackageId
			};
			Ajax.put('/api/cps/addBandwidthPackageIp', params,{
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(() => {
				this.doClose();
				this.$emit('refresh');
				this.$message.success(this.$t('privateNetInstance.operateSuccess'));
			}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
			}).finally(() => {
				this.doClose();
			});
		},
		// 清空表单
		doReset(formName) {
			this.$refs[formName].resetFields();
		},
		// 获取eip列表数据
		getEipListData() {
			this.refreshLoading = true;
		  	const param = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
				hasJoinBandwidthPackage: 'no',
				billingStatus: 'stop',
				charge: 'postpaid_by_duration',
				lineType: this.detailData.lineType,
                skipUnchargedData: true
		  	};
		  	Ajax.get('/api/cps/listElasticIps',param).then(res=>{
		  		this.refreshLoading = false;
				const list = res.data.elasticIps;
				this.eipListData = list.filter(item => item.charge.chargeStatus === 'normal');
				this.total = res.data.totalCount;
		  	}).catch(err => {
		  		const { response } = err.data;
				try {
					const json = response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
				this.refreshLoading = false;
		  	});
		},
		// 切换当前页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getEipListData();
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getEipListData();
		},

		handleSelectionChange(val) {
			this.selectIpCount = val.length;
        	this.multipleSelection = val;
      	}
	}
};
</script>

<style lang="scss">
	@import '../../../assets/scss/paginationCommon.scss';
	@import 'style';
</style>



// WEBPACK FOOTER //
// src/components/sbw/addIp/AddIp.vue